// @flow
export type Error =
  | {| message: string |}
  | {|
      message: string,
      startLineNumber: number,
      startColumn: number,
      endLineNumber: number,
      endColumn: number,
    |};

// A LocatableError is an error that can be attributed to a
// particular location in source code. It contains location
// information whose primary intent is to be able to annotate
// the source code with inline error messages. The location
// format matches that expected by Monaco.
export type LocatableError = {|
  message: string,
  startLineNumber: number,
  startColumn: number,
  endLineNumber: number,
  endColumn: number,
  // This was tacked on later to try to add some metadata about the type of
  // error. Primary intent was so that a particular category of error could
  // be ignored in the publication dashboard. It wasn't done very methodically
  // though, so really needs a proper design that accomodates all usages of
  // LocatableErrors, and is then used consistently (ie. it should not be
  // optional).
  extra?: { [string]: mixed },
|};

export type DocType =
  | 'RetrofittedStudentLesson'
  | 'RetrofittedStudentLessonTeacherNote'
  | 'Worksheet'
  | 'AnswerKey'
  | 'PrimaryTeacherNote'
  | 'Playground'
  | 'EngageActivity'
  | 'ActivityTeacherNote'
  | 'SolidifyLesson'
  | 'SolidifyTeacherNote'
  | 'StudentSubtopicOverview'
  | 'TopicOverview'
  | 'TopicAssessment'
  | 'TopicAnswerKey'
  | 'TeacherSubtopicOverview'
  | 'EngageActivityNote'
  | 'Investigation'
  | 'InvestigationTeacherNote'
  | 'Glossary';

export const defaultLanguage: 'English' = 'English';

/* Flow doesn't implement an $ArrayValues utility type
   An issue has been open for it for a while: https://github.com/facebook/flow/issues/961
   But has yet to be actions. Below is the recommended approach.
 */
const languagesObj: {| English: string, Spanish: string |} = {
  [defaultLanguage]: '',
  Spanish: '',
};

export type LanguageType = $Keys<typeof languagesObj>;
export const languages: Array<LanguageType> = Object.keys(languagesObj);
